const INIT = 'INIT';
const LOAD = 'LOAD';
const ERROR = 'ERROR';

export {
  INIT,
  LOAD,
  ERROR,
};



// WEBPACK FOOTER //
// ./src/components/stateful/ProfileIcon/STATES.js